/* global sendError */

/*
 * Function that shows / hides password of a password input inside
 * div with id;
 * @param {string} id
 * The div id, in where the password input is located.
 */
function showPassword(id) {
    window.event.preventDefault();
    if ($(`#${id} input`).attr("type") === "text") {
        $(`#${id} input`).attr("type", "password");
        $(`#${id} i`).addClass("fa-eye-slash");
        $(`#${id} i`).removeClass("fa-eye");
    } else if ($(`#${id} input`).attr("type") === "password") {
        $(`#${id} input`).attr("type", "text");
        $(`#${id} i`).removeClass("fa-eye-slash");
        $(`#${id} i`).addClass("fa-eye");
    }
}

/*
 * When the DOM with all its elements are loaded.
 */
$(function () {
    $(".new-password").on("keyup", function () {
        $.post({
            data: {
                password: $(this).val()
            },
            url: "/password_verification",

            headers: {
                "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")
            }
        })
            .done(data => {
                if (data !== "ok" && Array.isArray(data)) {
                    const text = data.join("<br>");
                    $("#password-help-block").html(text);
                    $("#password-help-block").removeClass("d-none");
                } else {
                    $("#password-help-block").html("");
                    $("#password-help-block").addClass("d-none");
                }
            })
            .fail(data => {
                sendError(data);
            })
            .always(() => {});
    });

    $("#show_hide_password a").on("click", _ => {
        showPassword("show_hide_password");
    });

    $("#show_hide_password_confirm a").on("click", _ => {
        showPassword("show_hide_password_confirm");
    });
});
